import React from 'react';
import { Check } from 'lucide-react';
export interface TimelineStepMeta {
  time?: string;
  actor?: string;
  note?: string;
}
interface TimelineTrackerProps {
  stages: readonly string[] | string[];
  currentStage: string;
  /** Optional per-stage metadata keyed by the stage label. */
  meta?: Record<string, TimelineStepMeta>;
}
export function TimelineTracker({
  stages,
  currentStage,
  meta
}: TimelineTrackerProps) {
  const currentIdx = stages.indexOf(currentStage);
  return <div className="relative space-y-6 before:absolute before:inset-0 before:ml-[15px] before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-border/50 before:to-transparent" data-id="element-517">
      {stages.map((stage, index) => {
      const isCompleted = index < currentIdx;
      const isCurrent = index === currentIdx;
      const stageMeta = meta?.[stage];
      const time = stageMeta?.time ?? (isCompleted ? '24 Okt 14:30' : isCurrent ? 'Hari ini 09:15' : '--:--');
      const note = stageMeta?.note ?? (isCompleted ? `Tahap ${stage} telah diselesaikan sesuai protokol operasional standar.` : isCurrent ? `Sedang dalam tahap ${stage}. Menunggu verifikasi dan tindakan lebih lanjut dari personel terkait.` : `Tahap ${stage} akan dimulai setelah tahap sebelumnya selesai diverifikasi.`);
      return <div key={stage} aria-current={isCurrent ? 'step' : undefined} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-518">
            {/* Icon/Node */}
            <div className={`flex items-center justify-center w-8 h-8 rounded-full border-2 shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_0_4px_var(--background)] z-10 ${isCompleted ? 'bg-[var(--status-active)] border-[var(--status-active)] text-black' : isCurrent ? 'bg-primary/20 border-primary text-primary shadow-[0_0_15px_rgba(var(--primary),0.5)] animate-pulse' : 'bg-background border-muted-foreground/30 text-muted-foreground'}`} data-id="element-519">
              {isCompleted ? <Check className="w-4 h-4" data-id="element-520" /> : isCurrent ? <div className="w-2 h-2 rounded-full bg-primary" data-id="element-521" /> : <div className="w-2 h-2 rounded-full bg-muted-foreground/30" data-id="element-522" />}
            </div>

            {/* Content Card */}
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded border border-border/30 bg-black/20 backdrop-blur-sm transition-all duration-300 hover:bg-black/40" data-id="element-523">
              <div className="flex items-center justify-between mb-1 gap-2" data-id="element-524">
                <h4 className={`font-mono text-sm font-bold uppercase tracking-widest ${isCompleted ? 'text-[var(--status-active)]' : isCurrent ? 'text-primary text-glow-primary' : 'text-muted-foreground'}`} data-id="element-525">
                  {stage}
                </h4>
                <span className="text-[10px] font-mono text-muted-foreground shrink-0" data-id="element-526">
                  {time}
                </span>
              </div>
              <p className="text-xs text-muted-foreground/80 font-mono" data-id="element-527">
                {note}
              </p>
              {stageMeta?.actor && <p className="text-[10px] font-mono text-primary/70 mt-2 uppercase tracking-widest" data-id="element-528">
                  PJ: {stageMeta.actor}
                </p>}
            </div>
          </div>;
    })}
    </div>;
}